module.exports = __webpack_public_path__ + "img/06_Effective Negotiator.2920e00c.svg";